import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const Testimonials = () => {
  const { t } = useTranslation('testimonials');

  return (
    <section className={theme.section + ' bg-background-primary'}>
      <div className={theme.container}>
        <h2 className={theme.text.h1 + ' text-center mb-12'}>
          {t('title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {t('testimonials', { returnObjects: true }).map((testimonial, index) => (
            <div key={index} className="rounded-lg bg-[#6D9773] border border-white/20 p-6 hover:shadow-lg transition-shadow duration-200">
              <p className="text-white/90 italic mb-4">
                "{testimonial.text}"
              </p>
              <p className="text-white font-bold">
                — {testimonial.author}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;